module.exports = __webpack_public_path__ + "img/Choose_Programme_F_WHEN.25d1c0e4.jpg";